import { IFindCallerObject, IPersonalDataObject } from '@vfit/shared/models';

export const DEFAULT_FIND_CALLER: IFindCallerObject = {
  activeSimMobile: false,
  individualRef: {
    msisdn: '',
    email: '',
  },
  selectedContactMedium: {
    field: '',
    fieldType: '',
  },
  showOtp: false,
  verifyOtp: '',
  customerHasActiveSubs: false,
};
export const DEFAULT_DATA: IPersonalDataObject = {
  owningIndividual: {
    nation: '',
    fiscalCode: '',
    firstName: '',
    lastName: '',
    contactMedium: [
      {
        type: 'email',
        preferred: true,
        emailAddress: '',
      },
      { type: 'phone', preferred: false, phoneNumber: '' },
    ],
    identification: [
      {
        identificationType: '',
        nationality: '',
        identificationNumber: '',
        expirationDate: '',
      },
    ],
  },
  isValid: false,
  isLogged: false,
};
export const CONTEXT_KEY = 'ctxk';

export const DEFAULT_PRODUCT = {};

export const DEFAULT_SLIDES_GO_BACK = -1;
